module.exports = __webpack_public_path__ + "img/titlebar.e362e959.jpg";